export default __webpack_public_path__ + "static/media/tick-circle-exito.86da7a95.svg";